export interface EmptyCopy {
  title: string
  message: string
}

export function getPropertyAwareCopy(propertyName: string | null): EmptyCopy {
  if (!propertyName) {
    return {
      title: 'Select a property to begin',
      message: 'Choose a property from the top bar to see data here.',
    }
  }
  return {
    title: `No data for ${propertyName} yet`,
    message: "We're ready when you are — this view will light up as activity rolls in.",
  }
}
